<template>
  <div class="wrapper" data-app>
    <div class="box-content">
      <div v-for="(item, index) in services" :key="index">
        <div @click="toggleIsShow(index)" :key="index" class="box-header">
          <!-- flex-shrink-0 -->
          <img
            class="flex-shrink-"
            v-if="item?.can_payment === 1"
            :src="bg.icon_checked"
            width="20px"
          />
          <img
            class="flex-shrink-"
            v-if="item?.can_payment !== 1"
            :src="bg.icon_circle"
            width="18px"
          />

          <div class="content-wrapper">
            <div class="content-info">
              <span class="title">{{ item?.name_unit }}</span>
              <span class="quantity"
                >{{ $t("quantity") }} {{ item?.listData?.length }}</span
              >
              <span
                class="status"
                v-if="
                  item &&
                    item.num_payment !== undefined &&
                    item.listData &&
                    item.listData.length !== undefined
                "
              >
                <span
                  v-if="
                    item.num_payment > 0 &&
                      item.num_payment === item.listData.length
                  "
                  style="color: #1BC88B"
                  >{{ $t("paid") }}</span
                >
                <span
                  v-else-if="
                    item.num_payment > 0 &&
                      item.num_payment < item.listData.length
                  "
                  style="color: #1BC88B"
                  >{{ $t("paid") }} {{ item?.num_payment }}/{{
                    item?.listData?.length
                  }}</span
                >
                <span v-else style="color: red">{{ $t("unpaid") }}</span>
              </span>
            </div>
            <div class="price-info">
              <span class="price">{{ formatNumber(item?.amount) }} đ</span>
              <div class="coin-info">
                <img :src="icons.iconCoin" width="15px" />
                <span class="currency">{{ formatNumber(item?.refund) }} đ</span>
              </div>
            </div>
          </div>
          <div class="arrow-icon flex-shrink-0">
            <img v-if="!isShow[index]" :src="bg.icon_drop_right" />
            <img v-if="isShow[index]" :src="bg.icon_drop_down" />
          </div>
        </div>
        <div v-if="isShow[index]" class="details">
          <div v-if="item.type === TYPE_SERVICE.BOOKING" class="detail-info">
            <span>
              <img :src="icons.iconTime" width="18px" alt="" />
              {{
                formatDate(
                  item?.booking_pax_detail?.date_played,
                  "DD/MM/YYYY - HH:mm"
                )
              }}
            </span>
            <span>
              <img :src="icons.iconLocation" width="18px" />
              {{ item?.booking_pax_detail?.facility?.title }}
            </span>
            <span>
              <img :src="icons.iconHole" width="18px" />
              {{ item?.booking_pax_detail?.number_hole }}
              {{ $t("hole") }}
            </span>
          </div>
          <DataDetailService
            style="margin-top: 8px;"
            :listData="item?.listData || []"
            :objectData="item"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from "@/plugins/init";
import iconCoin from "@/assets/img/svg/coin.svg";
import iconLocation from "@/assets/img/svg/location.svg";
import iconHole from "@/assets/img/svg/hole.svg";
import iconTime from "@/assets/img/svg/time.svg";
import iconCheckboxActive from "@/assets/img/svg/checkbox_active.svg";
import iconCheckboxInactive from "@/assets/img/svg/checkbox_inactive.svg";
import { TYPE_SERVICE } from "@/utils/helper.js";
import { formatDate } from "@/utils/formatData";
import { decodeToken } from "@/utils/auth";
import { getBackGround } from "@/utils/wapAuth";
import DataDetailService from "./DataDetailService.vue";
import dayjs from "dayjs";

export default {
  components: {
    DataDetailService
  }, //, Comment
  bodyClass: "data-services",
  props: {
    objDetail: {
      type: Object,
      default: () => {}
    },
    services: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      TYPE_SERVICE: TYPE_SERVICE,
      bg: getBackGround(),
      checked: false,
      large: "large",
      isShow: [],
      icons: {
        iconLocation,
        iconHole,
        iconTime,
        iconCheckboxActive,
        iconCheckboxInactive,
        iconCoin
      },
      form: {},
      isShowContent: false,
      windowWidth: window.innerWidth,
      isMobile: window.innerWidth < 768
    };
  },
  created() {},

  watch: {
    windowWidth(width) {
      this.$vuetify.breakpoint.width < 768
        ? (this.isMobile = true)
        : (this.isMobile = false);
    }
  },

  methods: {
    decodeToken,

    toggleIsShow(index) {
      if (!this.isShow) {
        this.isShow = []; // Khởi tạo isShow là một mảng nếu chưa tồn tại
      }
      // Nếu không có giá trị isShow cho chỉ số index, khởi tạo là false
      if (!this.isShow[index]) {
        this.$set(this.isShow, index, false);
      }
      // Toggle giá trị của isShow tại chỉ số index
      this.$set(this.isShow, index, !this.isShow[index]);
    },

    formatNumber,
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    formatDate
  },
  computed: {
    formattedDate() {
      return timestamp => {
        return dayjs(timestamp).format("DD/MM/YYYY - HH:mm");
      };
    },
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>
<style lang="scss" scoped>
.box-content {
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: #fff !important;
  //box-shadow: 0px 0px 4px 0px #00000026;
  overflow-y: auto;
  //max-height: 490px;
  margin-bottom: 136px;
}
.box-header {
  display: flex;
  padding: 10px;
  align-items: center;
}

.checkbox {
  margin-left: 2px;
}

.content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-right: 10px;
}

.content-info {
  margin-left: 10px;
}

.title {
  font-size: 14px;
  font-weight: 600;
}

.quantity,
.status {
  line-height: 1.4 !important;
  display: block;
  font-size: 14px;
  font-weight: 400;
}

.price {
  font-size: 14px;
  color: #fb7800;
  display: block;
}

.coin-info {
  display: flex;
  justify-content: right;
  //height: 25px;
}

.currency {
  display: block;
  margin-left: 5px;
  font-size: 12px;
  color: v-bind("bg.c_inherit_text");
}

.arrow-icon {
  width: 15px;
}

.details {
  background-color: v-bind("bg.c_background2");
  padding: 10px;
  transition: 5s;
}

.detail-info span {
  display: block;
  font-size: 14px;
  color: #fff;
  font-weight: 400;
}

.divider {
  //position: absolute;
  left: 0;
  right: 0;
  margin: 10px 0;
}

.content {
  margin-right: 12px;
  margin-left: 12px;
}

.el-checkbox__inner {
  border-radius: 50% !important;
}

.mobile {
  display: none;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .header-top {
    padding-top: 60px !important;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>

<style lang="scss">
.mt-0 {
  margin-top: 0 !important;
}

.pointer {
  cursor: pointer;
}

.border-1 {
  border: 1px solid #ababab;
  border-radius: 10px;
}

.icon-image {
  height: 30px !important;
}

.text-not-break {
  word-break: keep-all !important;
}
</style>
